import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, provide, ref } from 'vue';
import OpenSeadragon from 'openseadragon';
import { Deferred } from '@/utils/promise';
import { StOSD } from './osd.styled';
import { OSDExposition, props as propsDefinition } from './osd.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkOSD',
  props: propsDefinition,
  setup(__props, { expose }) {

const props = __props

const el = ref();

let viewer: OpenSeadragon.Viewer;
const isReadyDeferrer = Deferred<OSDExposition>();
const isReady = () => isReadyDeferrer.promise;

const updateViewer = (dziPath: string) => {
  viewer.destroy();

  viewer = OpenSeadragon({
    element: el.value,
    showNavigationControl: false,
    animationTime: 0.5,
    visibilityRatio: 0.1,
    ...props.options,
    tileSources: dziPath,
  });

  return viewer;
};

const exposedAttributes: OSDExposition = {
  isReady,
  getViewer: () => viewer,
  updateViewer,
  osd: OpenSeadragon,
};
onMounted(() => {
  viewer = OpenSeadragon({
    element: el.value,
    showNavigationControl: false,
    animationTime: 0.5,
    visibilityRatio: 0.1,
    ...props.options,
  });
  isReadyDeferrer.resolve(exposedAttributes);
});
provide<OSDExposition>(props.injectionKey, exposedAttributes);
expose(exposedAttributes);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StOSD), _normalizeProps(_guardReactiveProps(_ctx.$props)), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "el",
        ref: el,
        class: "h-full w-full"
      }, null, 512),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})